export const createActionMeta = (actionMeta)=>({
        requestUuid: crypto.randomUUID(),
        timestamp: Date.now(),
        ...actionMeta ?? {}
    });
